import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionNukeAccount($input: NukeAccountActionInput!) {
    actionNukeAccount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
    }
  }
  ${ErrorMessageInfo}
`;
